import { useLanguage } from './language-context';

// en/bn switch (i18n toggle, CLAUDE.md) — the merchant design's top-bar control (M:190
// `langToggleLabel`): one pill that names the OTHER language ("বাং" while English
// shows, "EN" while Bangla shows) and flips to it. Persists via the language context;
// every screen re-renders with the new dictionary. Duplicated per surface (CB-10).
// `menuItem` when it sits inside the account menu (a menu may only own menu items).
export function LanguageToggle({ menuItem = false }: { menuItem?: boolean } = {}) {
  const { lang, setLang, t } = useLanguage();
  const next = lang === 'en' ? 'bn' : 'en';
  return (
    <button
      type="button"
      className="lang-btn"
      role={menuItem ? 'menuitem' : undefined}
      lang={next}
      aria-label={`${t('dc70.lang.switch')}: ${t(next === 'bn' ? 'lang.bn' : 'lang.en')}`}
      onClick={() => setLang(next)}
    >
      {t(next === 'bn' ? 'lang.bn_short' : 'lang.en_short')}
    </button>
  );
}
